module.exports = __webpack_public_path__ + "static/media/7.question_loop.6a7b436d.mp4";